// Constants
import { ADDONS, COMPANY_TYPES_BILLING } from '@/constants'
// Components
import FormButtons from '@/components/ui/FormButtons'
import GoogleMapAutocomplete from '@/components/ui/GoogleMapAutocomplete'
// Mixins
import addonsMixin from '@/mixins/addonsMixin'
import formMixin from '@/mixins/formMixin'
import uiMixin from '@/mixins/uiMixin'
// Vuelidate plugin
import { validationMixin } from 'vuelidate'
import { required } from 'vuelidate/lib/validators'
// Vuex
import { mapGetters, mapActions } from 'vuex'
// Utils
import { get, cloneDeep } from 'lodash'
// Validate
import { validDNI, validCIF, validNIE } from 'spain-id'
// Filters
import { formatPhoneNumber } from '@/filters'
import { isValidNumberForRegion } from '@/utils'

export default {
  name: 'CompanyBillingDataForm',
  components: { FormButtons, GoogleMapAutocomplete },
  mixins: [addonsMixin, formMixin, uiMixin, validationMixin],
  data() {
    return {
      // Form
      formFields: {
        billingName: null,
        billingCompanyType: null,
        billingAddress: null,
        billingExtraAddress: null,
        cif: null,
        phone: null
      },
      formFieldsValidations: {
        billingName: {
          required: 'Campo obligatorio'
        },
        billingCompanyType: {
          required: 'Campo obligatorio'
        },
        billingAddress: {
          required: 'Debe seleccionar una de las direcciones sugeridas'
        },
        cif: {
          required: 'Campo obligatorio',
          vat: 'El número indicado no es valido para su pais de residencia'
        },
        phone: {
          numberFormat: 'Formato incorrecto de teléfono'
        }
      },
      // Others
      companyTypes: Object.values(COMPANY_TYPES_BILLING),
      countryCode: 'ES'
    }
  },
  computed: {
    ...mapGetters('company', ['companyData'])
  },
  watch: {
    'formFields.billingAddress': {
      handler(value) {
        this.countryCode = get(value, 'country_short', 'ES')
      },
      immediate: true
    }
  },
  mounted() {
    this.getEveryNeededData()
  },
  methods: {
    ...mapActions('company', ['updateCompanyConfigsData']),
    /**
     * Obtengo/establezco todo los datos iniciales del componente
     */
    getEveryNeededData() {
      // Establezco datos de los campos del formulario
      this.setFormFieldsValues()
    },
    /**
     * Establecemos los datos de los campos del formulario
     */
    setFormFieldsValues() {
      const companyConfig = get(this.companyAddonsSetupByUser, ADDONS.company, {})

      // Campos formulario
      this.formFields = {
        billingName: companyConfig.billingName || this.companyData.name,
        billingCompanyType: companyConfig.billingCompanyType,
        billingAddress: cloneDeep(companyConfig.billingAddress),
        billingExtraAddress: companyConfig.billingExtraAddress,
        cif: companyConfig.cif || this.formFields.cif,
        phone: companyConfig.phone
      }
    },
    /**
     * Is triggering after the form is correctly
     * validated by "Vuelidate"
     */
    async afterSubmit() {
      // Actualizamos configuraciones
      await this.updateCompanyConfigsData({
        id: this.companyData.id,
        addOns: [
          {
            id: ADDONS.company,
            configFields: {
              ...this.formFields,
              phone: formatPhoneNumber(this.formFields.phone, this.countryCode)
            }
          }
        ]
      })

      // show info
      this.modifyAppAlert({
        text: 'Los cambios se guardaron correctamente',
        visible: true
      })
    }
  },

  // Validations with Vuelidate
  validations() {
    const codeCountry = get(this.formFields.billingAddress, 'country_short', null)

    return {
      formFields: {
        billingName: {
          required
        },
        billingCompanyType: {
          required
        },
        billingAddress: {
          required
        },
        billingExtraAddress: {},
        cif:
          // Solo validamos a los españoles
          codeCountry === 'ES'
            ? {
                required,
                vat: (value) => {
                  // DNI, CIF or NIE
                  return validDNI(value) || validCIF(value) || validNIE(value)
                }
              }
            : {},
        phone: {
          numberFormat: (value) => {
            return isValidNumberForRegion(value, this.countryCode)
          }
        }
      }
    }
  }
}
